module.exports =
/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
/******/ 		}
/******/ 	};
/******/
/******/ 	// define __esModule on exports
/******/ 	__webpack_require__.r = function(exports) {
/******/ 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
/******/ 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
/******/ 		}
/******/ 		Object.defineProperty(exports, '__esModule', { value: true });
/******/ 	};
/******/
/******/ 	// create a fake namespace object
/******/ 	// mode & 1: value is a module id, require it
/******/ 	// mode & 2: merge all properties of value into the ns
/******/ 	// mode & 4: return value when already ns object
/******/ 	// mode & 8|1: behave like require
/******/ 	__webpack_require__.t = function(value, mode) {
/******/ 		if(mode & 1) value = __webpack_require__(value);
/******/ 		if(mode & 8) return value;
/******/ 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
/******/ 		var ns = Object.create(null);
/******/ 		__webpack_require__.r(ns);
/******/ 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
/******/ 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
/******/ 		return ns;
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = "./src/index.ts");
/******/ })
/************************************************************************/
/******/ ({

/***/ "./src/index.ts":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);

// EXTERNAL MODULE: external "react"
var external_react_ = __webpack_require__("react");
var external_react_default = /*#__PURE__*/__webpack_require__.n(external_react_);

// CONCATENATED MODULE: ./src/TestAttributeContext.ts

/* harmony default export */ var TestAttributeContext = (Object(external_react_["createContext"])({
  appendedScopes: ''
}));
// CONCATENATED MODULE: ./src/TestProvider.tsx



var TestProvider_TestProvider = function TestProvider(_ref) {
  var children = _ref.children,
      scope = _ref.scope;
  var context = Object(external_react_["useContext"])(TestAttributeContext);
  var appendedScopes = "" + (context.appendedScopes || '') + scope + "_";
  return /*#__PURE__*/external_react_default.a.createElement(TestAttributeContext.Provider, {
    value: {
      appendedScopes: appendedScopes
    }
  }, children);
};

/* harmony default export */ var src_TestProvider = (TestProvider_TestProvider);
// CONCATENATED MODULE: ./src/appendTestContext.tsx



var appendTestContext_appendTestContext = function appendTestContext(scope) {
  return function (Component) {
    return function (props) {
      return /*#__PURE__*/external_react_default.a.createElement(src_TestProvider, {
        scope: scope
      }, /*#__PURE__*/external_react_default.a.createElement(Component, props));
    };
  };
};

/* harmony default export */ var src_appendTestContext = (appendTestContext_appendTestContext);
// EXTERNAL MODULE: external "vanillas/toCamelCase"
var toCamelCase_ = __webpack_require__("vanillas/toCamelCase");
var toCamelCase_default = /*#__PURE__*/__webpack_require__.n(toCamelCase_);

// CONCATENATED MODULE: ./src/withTestFunc.tsx
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }





var withTestFunc_getTestAttributes = function getTestAttributes(_ref, baseAttr, detail) {
  var appendedScopes = _ref.appendedScopes;

  if (baseAttr === void 0) {
    baseAttr = '';
  }

  var attr = {
    'data-cv-test': toCamelCase_default()("" + (appendedScopes || '') + baseAttr)
  };

  if (detail) {
    attr['data-cv-test-detail'] = detail;
  }

  return attr;
};

var makeGetTestAttributes = function makeGetTestAttributes(context) {
  return function (baseAttr, detail) {
    return withTestFunc_getTestAttributes(context, baseAttr, detail);
  };
};

var withTestFunc_withTestFunc = function withTestFunc(Component) {
  return function (props) {
    return /*#__PURE__*/external_react_default.a.createElement(TestAttributeContext.Consumer, null, function (context) {
      return /*#__PURE__*/external_react_default.a.createElement(Component, _extends({}, props, {
        getTestAttributes: makeGetTestAttributes(context)
      }));
    });
  };
};

/* harmony default export */ var src_withTestFunc = (withTestFunc_withTestFunc);
// CONCATENATED MODULE: ./src/useTestFunc.ts




var useTestFunc_useTestFunc = function useTestFunc() {
  return makeGetTestAttributes(Object(external_react_["useContext"])(TestAttributeContext));
};

/* harmony default export */ var src_useTestFunc = (useTestFunc_useTestFunc);
// CONCATENATED MODULE: ./src/index.ts
/* concated harmony reexport appendTestContext */__webpack_require__.d(__webpack_exports__, "appendTestContext", function() { return src_appendTestContext; });
/* concated harmony reexport useTestFunc */__webpack_require__.d(__webpack_exports__, "useTestFunc", function() { return src_useTestFunc; });
/* concated harmony reexport withTestFunc */__webpack_require__.d(__webpack_exports__, "withTestFunc", function() { return src_withTestFunc; });





/***/ }),

/***/ "react":
/***/ (function(module, exports) {

module.exports = require("react");

/***/ }),

/***/ "vanillas/toCamelCase":
/***/ (function(module, exports) {

module.exports = require("vanillas/toCamelCase");

/***/ })

/******/ });
//# sourceMappingURL=index.js.map